import { useDispatch, useSelector } from "react-redux";

import {
    PredictionBarChart,
    ComparisonAndConfidence,
    PredictionMarketPotentialBestOutbounds,
    DownloadLoads,
    RpmVsDistance,
} from "@/components/dataPages";
import { ErrorPage } from "@/components/common/errors";
import React, { useEffect } from "react";
import { clearMarketPotentialState } from "@/state/marketPotentialSlice";
import { setSearchType } from "@/state/searchInputSlice";
import { cn } from "@/utils/css";
import { useIsDownloadsEnabled } from "@/services/featureFlags";

export const PredictionMarketPotential = () => {
    const { data, error } = useSelector((state) => state.marketPotential);
    const dispatch = useDispatch();
    const downloadsEnabled = useIsDownloadsEnabled();

    useEffect(() => {
        dispatch(setSearchType("market_potential"));

        return () => {
            dispatch(clearMarketPotentialState());
        };
    }, []);

    return !error ? (
        <div className="flex flex-col lg:grid lg:grid-cols-[330px_calc(100%_-_350px)] lg:gap-[20px] items-start w-full h-full pt-1">
            <div
                className={cn(
                    "flex flex-col lg:mr-5 w-full bg-cm-p-surface pt-5 pb-6 px-6 drop-shadow-[0_4px_4px_rgba(0,0,0,0.05)] rounded-lg min-h-[688px] justify-between",
                    {
                        "min-h-[747px]": downloadsEnabled,
                    },
                )}
            >
                <RpmVsDistance />
                <div className="w-full h-[1px] bg-cm-p-outline-variation my-[26px]" />
                <ComparisonAndConfidence />
                <div className="w-full h-[1px] bg-cm-p-outline-variation my-[26px]" />
                <div className="w-full">
                    <PredictionBarChart
                        title="Outb. load volume"
                        tooltipText="Shows the daily outbound load volume from this market, expressed as a percentage."
                    />
                </div>
                <DownloadLoads filePath={data?.loadCsvUrl} className="mt-4" />
            </div>
            <div className="flex w-full bg-cm-p-surface pt-4 pb-6 px-8 drop-shadow-[0_4px_4px_rgba(0,0,0,0.05)] rounded-lg lg:min-h-full">
                <PredictionMarketPotentialBestOutbounds />
            </div>
        </div>
    ) : (
        <ErrorPage
            title="Oops! Something went wrong."
            description="Something went wrong while loading this page. If the problem persists, report it to our team using the feedback button on home page."
        />
    );
};
